import { createAction, props } from '@ngrx/store';

/**
 * Navigator device action - updates user agent
 */
export const navigatorDevice = createAction(
  '[Device] Navigator Device',
  props<{ userAgent?: string }>()
);

/**
 * Device resolution action - updates screen resolution
 */
export const deviceResolution = createAction(
  '[Device] Device Resolution',
  props<{ resolution?: number[] }>()
);